import styled from '@emotion/styled'
import { Grid } from '@mui/material'

const shimmer = `
	@keyframes propertyCardShimmer {
		0% { background-position: -300px 0; }
		100% { background-position: 300px 0; }
	}
`

const SkeletonBlock = styled.div`
	${shimmer}
	border-radius: 6px;
	background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
	background-size: 600px 100%;
	animation: propertyCardShimmer 1.4s ease infinite;
`

const SkeletonCard = styled.div`
	border: 2px solid transparent;
	border-radius: 8px;
	overflow: hidden;
`

const SkeletonImage = styled(SkeletonBlock)`
	height: 190px;
	border-radius: 0;
`

const SkeletonBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 12px 4px 0;
`

const SkeletonFeaturesRow = styled.div`
	display: flex;
	gap: 12px;
`

const SkeletonButtonsRow = styled.div`
	display: flex;
	gap: 8px;
	min-height: 40px;
	padding-top: 4px;
`

interface PropertyCardSkeletonGridProps {
	count?: number
	columns?: number
}

export const PropertyCardSkeletonGrid = ({ count = 6, columns = 2 }: PropertyCardSkeletonGridProps) => {
	const sizeCard = Math.floor(12 / columns)
	return (
		<Grid container rowSpacing={{ xs: 3, md: 3 }} columnSpacing={{ md: 2 }}>
			{Array.from({ length: count }).map((_, i) => (
				<Grid item xs={12} md={sizeCard} key={i}>
					<SkeletonCard aria-hidden="true">
						<SkeletonImage />
						<SkeletonBody>
							<SkeletonBlock style={{ width: '35%', height: '12px' }} />
							<SkeletonBlock style={{ width: '80%', height: '18px' }} />
							<SkeletonBlock style={{ width: '45%', height: '16px' }} />
							<SkeletonFeaturesRow>
								<SkeletonBlock style={{ width: '25%', height: '12px' }} />
								<SkeletonBlock style={{ width: '25%', height: '12px' }} />
								<SkeletonBlock style={{ width: '25%', height: '12px' }} />
							</SkeletonFeaturesRow>
							<SkeletonButtonsRow>
								<SkeletonBlock style={{ flex: 1, height: '36px' }} />
								<SkeletonBlock style={{ flex: 1, height: '36px' }} />
							</SkeletonButtonsRow>
						</SkeletonBody>
					</SkeletonCard>
				</Grid>
			))}
		</Grid>
	)
}
